import Lead from "./Lead" ;
import DBObject from "../utils/DBObject" ;
import CloneContext from "../utils/CloneContext" ;


  export default  class  HotList extends  DBObject {  private static readonly _IMAGEURLS: number = 0 ;
  private static readonly _LEAD: number = 1 ;
  public id: number = 0 ;
  public otherMaster: DBObject ;
  private _imageUrls: string = '' ;
  private _lead: Lead = null ;
 public constructor ( d3eParams ? : Partial<{imageUrls: string, lead: Lead}> ) {
 super();

this.setImageUrls(d3eParams?.imageUrls ?? '');

this.setLead(d3eParams?.lead ?? null);
 }
  public get d3eType (  ) : string {
 return 'HotList' ; 
 }
  public clear (  ) : void {
 this.d3eChanges.clear();
 }
  public get imageUrls (  ) : string {
 return this._imageUrls ; 
 }
  public setImageUrls ( val : string ) : void {
 let isValChanged :boolean=this._imageUrls !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(HotList._IMAGEURLS,this._imageUrls);

this._imageUrls=val;

this.fire('imageUrls',this);
 }
  public get lead (  ) : Lead {
 return this._lead ; 
 }
  public setLead ( val : Lead ) : void {
 let isValChanged :boolean=this._lead !== val;

if ( !isValChanged ) {
 return ; 
 }

this.updateD3EChanges(HotList._LEAD,this._lead);

this.updateObservable('lead',this._lead,val);

this._lead=val;

this.fire('lead',this);
 }
  public get ( field : number ) : any {
 switch ( field ) {
 case HotList._IMAGEURLS : {
 return this._imageUrls ; 
 }

case HotList._LEAD : {
 return this._lead ; 
 }
 default: {
 return null ; 
 }
 }
 }
  public updateD3EChanges ( index : number,value : any ) : void {
 if ( this.lockedChanges() ) {
 return ; 
 }

super.updateD3EChanges(index,value);
 }
  public restore (  ) : void {
 /*
TODO: Might be removed
*/

this.d3eChanges.restore(this);
 }
  public deepClone ( clearId = true ) : HotList {
 let ctx :CloneContext=new CloneContext({ 'clearId':clearId });

return ctx.startClone(this) ; 
 }
  public collectChildValues ( ctx : CloneContext ) : void {
  }
  public deepCloneIntoObj ( dbObj : DBObject,ctx : CloneContext ) : void {
 let obj :HotList=( dbObj as HotList );

obj.id=this.id;

obj.setImageUrls(this._imageUrls);

obj.setLead(this._lead);
 }
  public set ( field : number,value : any ) : void {
 switch ( field ) {
 case HotList._IMAGEURLS : {
 this.setImageUrls(( value as string ));
 break; }

case HotList._LEAD : {
 this.setLead(( value as Lead ));
 break; }
 }
 }
 }